import { PLATFORM } from '@/enums/phoneModel';
import { isApp } from './appHooks';
export const phoneModel = () => {
  const userAgent = navigator.userAgent;
  const isiOS = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  const isAndroid =
    userAgent.indexOf('Android') > -1 || userAgent.indexOf('Adr') > -1;
  return {
    isiOS,
    isAndroid,
  };
};

export const PLATFORMTYPE = () => {
  if (isApp()) {
    if (phoneModel().isiOS) {
      return PLATFORM.ios;
    }
    if (phoneModel().isAndroid) {
      return PLATFORM.android;
    }
  } else {
    return PLATFORM.web;
  }
};
export const PLATFORM_TYPE = () => {
  if (isApp()) {
    if (phoneModel().isiOS) {
      return 'ios';
    }
    if (phoneModel().isAndroid) {
      return 'android';
    }
  } else {
    return 'H5';
  }
};
export const getTransId = () => {
  const s = [];
  const hexDigits = '0123456789abcdef';
  for (let i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = '4'; // bits 12-15 of the time_hi_and_version field to 0010
  // @ts-ignore
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = '';
  return s.join('');
};
